import { KeycloakInstance } from "keycloak-js";
import { AuthProvider, UserIdentity } from "react-admin";

export default class KeycloakAuthProvider implements AuthProvider {
    protected keycloak: KeycloakInstance;

    constructor(keycloak: KeycloakInstance) {
        this.keycloak = keycloak;
    }

    checkAuth(params: any): Promise<void> {
        if (this.keycloak.authenticated) {
            return Promise.resolve(undefined);
        } else {
            return Promise.reject(undefined);
        }
    }

    checkError(error: any): Promise<void> {
        return Promise.resolve(undefined);
    }

    getIdentity(): Promise<UserIdentity> {
        const user : UserIdentity = {avatar: "", fullName: "", id: ""};

        if(this.keycloak.tokenParsed) {
            user.fullName = user.id = this.keycloak.tokenParsed['preferred_username'];
        }

        return Promise.resolve(user);
    }

    getPermissions(params: any): Promise<any> {
        return Promise.resolve(this.keycloak.realmAccess);
    }

    login(params: any): Promise<any> {
        // login is only possible via keycloak login form
        return Promise.reject(undefined);
    }

    logout(params: any): Promise<void | false | string> {
        return new Promise((resolve, reject) => {
            this.keycloak.logout().then(() => {
                resolve();
            })
        })
    }

}
